import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@material-ui/core';
import cx from 'classnames';
import { useObserver } from 'mobx-react';
import React from 'react';
import { translate } from '../../../../../../common/intl';
import { MomentFormats, useDate } from '../../../../../../common/utils/date';
import OverflowTooltip from '../../../../../components/OverflowTooltip';
import { getEquipmentOption } from '../hooks/useFetchData';
import { isDateOverdue } from '../utils';
import useStyles from './styles';
import TreeListCellWrapper from './TreelistCellWrapper';
import { CustomTreeListCellProps } from './types';

export const EBDateCell: React.FC<CustomTreeListCellProps> = (props) => {
  const { field = '', dataItem, hasChildren, onClick } = props;
  const option = useObserver(() => getEquipmentOption(dataItem?.equipmentId));
  const { getFormattedDateString, convertDateTimeToUserTz } = useDate();

  const getFormattedDate = (date) => {
    return date ? getFormattedDateString(convertDateTimeToUserTz(date, MomentFormats.MonthDateYear), MomentFormats.MonthDateYearTwoDigit) : '-';
  };

  const dueDate = option?.[field as 'calDueDate' | 'pmDueDate'];
  const displayValue = option ? getFormattedDate(dueDate) : undefined;
  const isExpired = displayValue ? isDateOverdue(displayValue) : false;
  const classes = useStyles({ hasChildren });

  return (
    <TreeListCellWrapper {...props}>
      <OverflowTooltip title={displayValue} placement="top" onClick={() => onClick?.({ dataItem })} interactive arrow deferred>
        <span className={cx(classes.Cell, { [classes.expired]: isExpired })}>{displayValue}</span>
        {isExpired && (<span>
          <FontAwesomeIcon
            size="lg"
            className={cx(classes.expired, classes.expiredIcon)}
            icon={ solid('circle-exclamation')}
          />
          <Typography component="span" variant="h5" className={cx(classes.expired, classes.overdueLabel)} >
            {translate('common.overdue')}
          </Typography>
        </span>)}
      </OverflowTooltip>
    </TreeListCellWrapper>
  );
};
